import { Directive, ElementRef, HostListener, Input, Renderer2, OnChanges, SimpleChanges } from "@angular/core";

/**
 * Applies mat-elevation-z class to the component it is applied to.
 * 
 * @export
 * @class MaterialElevationDirective
 * @implements {OnChanges}
 * 
 * copied from https://stackblitz.com/edit/angular-material-elevation-hover?file=src%2Fapp%2Fmaterial-elevation.directive.ts
 */
@Directive({
  selector: "[appMaterialElevation]"
})
export class MaterialElevationDirective implements OnChanges
{

  /**
   * The default elevation\starting elevation of the mat-elevation-z class.
   */
  @Input()
  public defaultElevation: number = 2;

  /**
   * The raised elevation\ending elevation of the mat-elevation-z class. blah blah
   */
  @Input()
  public raisedElevation: number = 8;

  /**
   * The Constructor
   * @param element Element attached
   * @param renderer For custom rendering
   */
  constructor(
    private element: ElementRef,
    private renderer: Renderer2
  )
  {
    this.setElevation(this.defaultElevation);
  }

  /**
   * Listens for changes on parent component.
   * @param _changes not used.
   */
  public ngOnChanges(_changes: SimpleChanges)
  {
    this.setElevation(this.defaultElevation);
  }

  /**
   * Listens for the mouseenter event.
   */
  @HostListener("mouseenter")
  public onMouseEnter()
  {
    this.setElevation(this.raisedElevation);
  }

  /**
   * Listens for the mouseleave event
   */
  @HostListener("mouseleave")
  public onMouseLeave()
  {
    this.setElevation(this.defaultElevation);
  }

  /**
   * Sets the mat-elevation-z class value.
   * @param amount amount to set mat-elevation class to.
   */
  private setElevation(amount: number)
  {
    // remove all elevation classes
    const classesToRemove = Array.from((this.element.nativeElement as HTMLElement).classList).filter(c => c.startsWith("mat-elevation-z"));
    classesToRemove.forEach((c) =>
    {
      this.renderer.removeClass(this.element.nativeElement, c);
    });

    // add the given elevation class
    const newClass = `mat-elevation-z${ amount }`;
    this.renderer.addClass(this.element.nativeElement, newClass);
  }
}
